import axios from "./AxiosService";

export default function addAPlan(membershipNumber) {
  return axios
    .post("addaplan", {
      MembershipNumber: membershipNumber
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error.response.data;
    });
}
